import { Track } from "./_/track";
import gsap, { reduced } from "../gsap";

/**
 * Scale Module
 * 
 * Scales an element based on scroll position within viewport.
 * 
 * Usage:
 * <div data-module="scale">
 *   <img data-scale src="..." />
 * </div>
 */
export class Scale extends Track {
  target;
  startScale;
  endScale;

  constructor(element) {
    super(element, {
      top: "bottom",
      bottom: "top",
      bounds: [0, 1],
    });

    if (reduced) return;

    this.target = element.querySelector("[data-scale]") || element;
    this.startScale = parseFloat(element.dataset.startScale) || 0.8;
    this.endScale = parseFloat(element.dataset.endScale) || 1;
  }

  handleScroll = (value) => {
    if (reduced) return;

    const scale = this.startScale + (this.endScale - this.startScale) * value;
    gsap.set(this.target, { scale });
  };

  transitionOut = () => {
    this.destroy();
  };
}

